import { render, staticRenderFns } from "./cell-width-resize.vue?vue&type=template&id=74b60a28&"
import script from "./cell-width-resize.vue?vue&type=script&lang=js&"
export * from "./cell-width-resize.vue?vue&type=script&lang=js&"
import style0 from "./cell-width-resize.vue?vue&type=style&index=0&id=74b60a28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports